import { useContext, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context'

export default function Anthropometry() {
  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)

  const { values = {}, setFieldValue, setValues } = allForms || {}

  const { anthropometry } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  useEffect(() => {
    const dataJson = JSON.stringify(anthropometry)
    if (!addMode && anthropometry && setValues && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      // Данные приходят как массив: [{ idantro, antroname, value, acquired }, ...]
      setValues(prev => ({
        ...prev,
        anthropometry: Array.isArray(anthropometry) ? [...anthropometry] : []
      }))
      if (updateInitialValues) {
        updateInitialValues('anthropometry', anthropometry)
      }
    }
  }, [anthropometry, addMode, setValues, updateInitialValues])

  // Обработчик изменения значения или даты
  const handleChange = (index, field, newValue) => {
    const currentData = Array.isArray(values.anthropometry) ? [...values.anthropometry] : []
    if (currentData[index]) {
      currentData[index] = { ...currentData[index], [field]: newValue }
      setFieldValue('anthropometry', currentData)
    }
  }

  const data = Array.isArray(values.anthropometry) ? values.anthropometry : []

  return (
    <div className={styles.tabWrapper}>
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Антропометрические данные</h3>
        <table className={styles.anthropometryTable}>
          <thead>
            <tr>
              <th>Параметр</th>
              <th>Значение</th>
              <th>Дата измерения</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.idantro || index}>
                  <td>{item.antroname || '-'}</td>
                  <td>
                    <input
                      value={item.value || ''}
                      onChange={(e) => handleChange(index, 'value', e.target.value)}
                      className={styles.anthropometryInput}
                    />
                  </td>
                  <td>
                    <input
                      type='date'
                      value={item.acquired || ''}
                      onChange={(e) => handleChange(index, 'acquired', e.target.value)}
                      className={styles.anthropometryInput}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} style={{ textAlign: 'center', color: '#666', padding: '2rem' }}>
                  {addMode ? 'Сначала сохраните основные данные' : 'Нет данных'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
